import { onBeforeMount, onUnmounted, ref } from 'vue';
import { ElMessageBox, ElNotification } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/notification/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/leftSlide/noContent.png';
const _withScopeId = n => (_pushScopeId("data-v-41932922"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "task_list",
  id: "task_list"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  class: "tip"
};
const _hoisted_5 = {
  key: 0,
  class: "error"
};
const _hoisted_6 = {
  key: 1,
  class: "creating"
};
const _hoisted_7 = {
  key: 2,
  class: "downing"
};
const _hoisted_8 = {
  class: "bottom"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  key: 3,
  class: "time"
};
const _hoisted_13 = {
  class: "no_more_data"
};
const _hoisted_14 = {
  key: 1,
  class: "empty"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-center noContent"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, "抱歉，暂无信息~")], -1));
const _hoisted_16 = [_hoisted_15];
import errImg from '@/assets/images/rightSlide/default.png';
import NoMoreData from '@/components/noMoreData.vue';
import { getTaskList, reCreatTask, deleteTask } from '@/api/chat';
import { getFilePort } from '@/api/role';
import { downloadFile } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'taskList',
  setup(__props) {
    onBeforeMount(async () => {
      getList();
      refresh();
    });
    onUnmounted(() => {
      timer && clearTimeout(timer);
    });
    const taskList = ref([]);
    const curIndex = ref(-1);
    const getList = async () => {
      const res = await getTaskList({
        page: 1,
        limit: 10000
      });
      taskList.value = res.records;
      console.log('taskList', taskList.value);
    };
    let timer = null;
    let time = 1000;
    const refresh = () => {
      timer = setTimeout(() => {
        getList();
        time = 10000;
        refresh();
      }, time);
    };
    const reCreat = async item => {
      await reCreatTask({
        taskId: item.id
      });
      getList();
      ElNotification({
        title: '已为您重新生成任务',
        message: '',
        type: 'success'
      });
    };
    const delTask = async item => {
      ElMessageBox.confirm('确认删除该任务？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteTask({
          taskId: item.id
        });
        ElNotification({
          title: '删除成功',
          message: '',
          type: 'success'
        });
        getList();
      });
    };
    const down = async item => {
      const fileName = item.taskType == 1 ? `${item.name}.mp3` : `${item.name}.png`;
      const fileType = item.taskType == 1 ? 'application/mp3' : 'application/png';
      try {
        item.isDownload = true;
        const data = await getFilePort({
          url: item.srtResult,
          fileName
        });
        downloadFile(data, fileName, fileType);
        item.isDownload = false;
      } catch (err) {
        item.isDownload = false;
      }
    };
    const showPreview = ref(false);
    const preViewList = ref([]);
    const closePreview = () => {
      showPreview.value = false;
      document.body.style.overflow = 'auto';
    };
    const preview = (item, index) => {
      preViewList.value = [item.srtResult];
      showPreview.value = true;
      document.body.style.overflow = 'hidden';
    };
    const itemClick = (item, index) => {
      curIndex.value = index;
      if (item.taskType == 2 && item.status == 2) {
        preview(item, index);
      }
    };
    const curAudioTime = ref(0);
    let audio; //音频实例
    let playIndex = -1; //播放中的数组下标
    const audios = ref([]);
    const initAudio = () => {
      audio = document.createElement('audio');
      audio.addEventListener('loadedmetadata', evt => {
        console.log('audio loadedmetadata');
        audio.play();
      });
      audio.addEventListener('error', evt => {
        console.error('音频加载失败', evt);
      });
      audio.addEventListener('ended', evt => {
        audios.value[playIndex].status = 0;
      });
    };
    const playOrPause = index => {
      if (audios.value[index].status == 0) {
        //暂停前一个正在播放的
        if (audios.value[playIndex]) {
          audios.value[playIndex].status = 0;
        }
        //开始播放
        playIndex = index;
        if (audios.value[index].downloadUrl == audio.getAttribute('src')) {
          audio.play();
        } else {
          audio.setAttribute('src', audios.value[index].downloadUrl);
        }
      } else {
        //暂停播放
        audio.pause();
      }
      audios.value[index].status = audios.value[index].status == 0 ? 1 : 0;
    };
    const pauseAudio = () => {
      if (!audio.paused) {
        audio.pause();
        audios.value[playIndex].status = 0;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_image_viewer = _resolveComponent("el-image-viewer");
      const _component_el_image = _resolveComponent("el-image");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _directive_lazyload = _resolveDirective("lazyload");
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(taskList).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(showPreview) ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 0,
        class: "img_view",
        "url-list": _unref(preViewList),
        "initial-index": 0,
        "hide-on-click-modal": true,
        "preview-teleported": true,
        onClose: closePreview
      }, null, 8, ["url-list"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(taskList), (vo, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item", {
            item_select: _unref(curIndex) == index
          }]),
          onClick: $event => itemClick(vo, index),
          key: index
        }, [vo.taskType == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [vo.srtResult ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          src: vo.srtResult,
          fit: "contain"
        }, null, 8, ["src"])) : _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_3, null, 512)), [[_directive_lazyload, _unref(errImg)]])], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [vo.status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, "生成失败")) : _createCommentVNode("", true), vo.status == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, "生成中")) : _createCommentVNode("", true), vo.isDownload ? (_openBlock(), _createElementBlock("div", _hoisted_7, "下载中")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [vo.status == 2 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "opt",
          onClick: _withModifiers($event => down(vo), ["stop"])
        }, [_createVNode(_component_svg_icon, {
          class: "icon",
          iconClass: "down"
        })], 8, _hoisted_9)) : _createCommentVNode("", true), [0, 2].includes(vo.status) ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "opt",
          onClick: _withModifiers($event => delTask(vo), ["stop"])
        }, [_createVNode(_component_svg_icon, {
          class: "icon icon_hover_red",
          iconClass: "delete"
        })], 8, _hoisted_10)) : _createCommentVNode("", true), vo.status == 0 ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "opt",
          onClick: _withModifiers($event => reCreat(vo), ["stop"])
        }, [_createVNode(_component_svg_icon, {
          class: "icon",
          iconClass: "refresh"
        })], 8, _hoisted_11)) : _createCommentVNode("", true), vo.taskType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_12, "00:08")) : _createCommentVNode("", true)])], 10, _hoisted_2);
      }), 128)), _createElementVNode("div", _hoisted_13, [_unref(taskList).length > 0 ? (_openBlock(), _createBlock(NoMoreData, {
        key: 0,
        domId: "task_list"
      })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _unref(taskList).length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16)) : _createCommentVNode("", true)], 64);
    };
  }
});